/* eslint-disable no-constant-condition */

class PackRegionNode {
  constructor(start, end, padding) {
    this.g0 = start;
    this.g1 = end;
    this.left = null;
    this.right = null;
    this.padding = padding || 0;
  }

  check(g0, g1) {
    let n = this;

    while (true) {
      const ln = n.left;
      const rn = n.right;
      if (ln && ln.g0 < g0 && ln.g1 > g1) {
        n = ln;
        continue;
      } else if (rn && rn.g0 < g0 && rn.g1 > g1) {
        n = rn;
        continue;
      } else if (!rn && !ln && n.g0 <= g0 && n.g1 >= g1) {
        return n;
      }
      return null;
    }
  }

  insert(g0, g1) {
    let n = this;

    while (true) {
      const ln = n.left;
      const rn = n.right;
      if (ln && ln.g0 < g0 && ln.g1 > g1) {
        n = ln;
        continue;
      } else if (rn && rn.g0 < g0 && rn.g1 > g1) {
        n = rn;
        continue;
      } else if (!rn && !ln && n.g0 <= g0 && n.g1 >= g1) {
        n.left = new PackRegionNode(n.g0 + this.padding, g0 - this.padding);
        n.right = new PackRegionNode(g1 + this.padding, n.g1 - this.padding);
        return n;
      }
      return null;
    }
  }
}

export default PackRegionNode;
